const Spinner = ({ className = "" }: { className?: string }) => (
  <div className={`flex justify-center py-20 ${className}`}>
    <div
      role="status"
      aria-label="Loading"
      className="size-8 animate-spin rounded-full border-2 border-gray-200 border-t-crayoBlue"
    />
  </div>
);

export default Spinner;
